export default "__VITE_ASSET__Dm4wF1Uu__"